module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e2666"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Grin_ISBN9781423600022_epub_c15_r1#d6e1",
      "id": "d7e1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e2716"
    }
  }, [_c('b', [_vm._v("ARCHITECTURE’S UNDERDOG ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e2766"
    }
  }, [_vm._v("A ranch house? Are you kidding me? Those homes are ugly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e2836"
    }
  }, [_vm._v("If you’re house hunting or live in one of the millions of ranches built across the nation after World War II, you’ve probably heard a sentiment like that from one of your less tactful friends. Maybe you even think so too.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e3006"
    }
  }, [_vm._v("But this book shows that there’s more to America’s architectural stepchild than first meets the eye. You say they don’t have the curb appeal of a Victorian or bungalow? That their attached carports and garages and sometimes bland facades don’t really do it for you?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e3176"
    }
  }, [_vm._v("Well, come inside a ranch house that still shows its midcentury roots and you’ll see why fifty years ago young homeowners found them to be cutting edge and their own piece of Tomorrow land.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e3346"
    }
  }, [_vm._v("The open floor plans that bring residents together in the kitchen/family/dining/living room foreshadowed today’s ubiquitous “great rooms,” yet were designed on a livable, human scale. The private bedroom wings, the walls of glass that flood the interior with light, and the sliding glass doors that erase the barrier between indoors and out—these are other hallmarks of the late-’40s through 1970s ranch. Durably built with materials that combine the natural (wood post-and-beam construction, aggregate and cork flooring, rock roofs and stone fireplaces) with the modern (Formica counters, radiant heated concrete floors, aluminum windows, plywood cabinetry)—these postwar homes may not look flashy but they were designed to last.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e3806"
    }
  }, [_vm._v("The homes may be decidedly modern looking, like the flat- or gable-roofed Joseph Eichler tracts in the San Francisco Bay area, or the butterfly roof houses in Palm Springs and Sarasota, Florida. Or they may be modest, unassuming L-shaped or split-level ranches that have been built so often across the nation that they’re virtually invisible. You probably drive past dozens of such homes on your way to work every day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e4066"
    }
  }, [_vm._v("We think that the midcentury ranch house deserves a place of honor in our hearts and minds, and we think that postwar neighborhoods should be preserved for the next generation. Buying, renovating, and living in a ranch-style home can be a great joy, and we’ll show you inspiring examples of people who “get” what a ranch house was designed to be. This mousey little wallflower of a home may very well be the stuff of your dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e4376"
    }
  }, [_vm._v("Here’s to the bad boy of architecture.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0007_001",
      "id": "d14e165",
      "src": "images/AtomicRanchBook_0007_001.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58c85077","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grin_ISBN9781423600022_epub_c16_r1.vue
// module id = 75
// module chunks = 0